import React, { useEffect, useState } from "react";
import { TextField } from "components/TextField";
import { styled } from "@mui/material/styles";

export interface TitleSectionProps {
  /** The string value for chart title */
  title: string;
  onChangeTitle: (name: string) => void;
}

export const TitleSection = ({
  title,
  onChangeTitle
}: TitleSectionProps): JSX.Element => {
  /** When local title is updated, wait 1s and request the whole changes */
  const [localTitle, setLocalTitle] = useState<string>(title || "");

  useEffect(() => {
    const timer = setTimeout(() => {
      onChangeTitle(localTitle);
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localTitle]);

  return (
    <SelectionWrap>
      {/* Title name input */}
      <TextField
        id="titleInput"
        label="Title name"
        fullWidth
        size="small"
        variant="outlined"
        maxLength={80}
        clearable
        value={localTitle || ""}
        onClear={() => setLocalTitle("")}
        onChange={event => setLocalTitle(event.target.value)}
      />
    </SelectionWrap>
  );
};

const SelectionWrap = styled("div")`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: ${({ theme }) => theme.spacing(2)};
`;
